export default "__VITE_ASSET__D548Lcb4__"